module.exports = __webpack_public_path__ + "img/job-card-user.3578686d.svg";